const loadedChunks = {};
// Override - will need to check this method every time we update webpack
__webpack_require__.e = _.wrap(__webpack_require__.e, function (e, chunkId) {
	if (loadedChunks[chunkId]) return e.apply(this, _.rest(arguments));

	dispatcher.trigger('netx:loading:chunk', chunkId);

	var promise = e.apply(this, _.rest(arguments));
	promise.then(function () {
		loadedChunks[chunkId] = true;
		dispatcher.trigger('netx:loaded:chunk', chunkId);
	});

	return promise;
});

const messageQueue = {};
const loadingQueue = {};
const initializingQueue = {};

/**
 * @class
 */
class Loading {
	/**
	 * @method
	 */
	constructor() {
		// Get backbone events (they are quite nice)
		_.extend(this, Backbone.Events);

		// Debounced/throttled methods
		this.checkMessage = _.throttle(this.checkMessage, 50, true);
		this.checkProgress = _.throttle(this.checkProgress, 16.666, true);

		this.progressAmt = 0;

		var el = (this.el = document.getElementById('nx-app-loader'));
		// Messaging
		this.messageEl = el.querySelector('#nx-app-message');
		this.messageTextEl = this.messageEl.querySelector('#nx-app-message-text');
		// Progress bar
		this.progressEl = el.querySelector('#nx-app-progress');
		this.progressWrapperEl = this.progressEl.querySelector(
			'#nx-progress-wrapper',
		);
		this.progressBarEl =
			this.progressWrapperEl.querySelector('#nx-progress-bar');
		// Splash screen
		this.splashEl = el.querySelector('#loading');

		// Hey, listen!
		this.listenTo(
			dispatcher,
			'netx:initializing:module',
			this.initializingModule,
		)
			.listenTo(dispatcher, 'netx:initialized:module', this.initializedModule)
			.listenTo(dispatcher, 'netx:loading:chunk', this.loadingChunk)
			.listenTo(dispatcher, 'netx:loaded:chunk', this.loadedChunk)
			.listenTo(dispatcher, 'netx:rest:loading', this.restLoading)
			.listenTo(dispatcher, 'netx:rest:loaded', this.restLoaded);
	}

	/**
	 * @method
	 * @param {function} cb Callback
	 */
	appLoaded(cb) {
		this.removeSplash(cb);
	}

	/**
	 * @method
	 */
	checkMessage() {
		this.hideMessageTimeout && clearTimeout(this.hideMessageTimeout);

		const messageEl = this.messageEl,
			messageTextEl = this.messageTextEl,
			messageKeys = _.keys(messageQueue),
			hasMessage = messageKeys.length > 0;

		if (hasMessage && !this.messageActive) {
			messageEl.classList.add('active');
			this.messageActive = true;
		}

		if (hasMessage) {
			messageTextEl.innerText = messageQueue[_.last(messageKeys)];
		} else if (this.messageActive) {
			this.hideMessageTimeout = setTimeout(() => {
				messageEl.classList.remove('active');
				this.messageActive = false;
				this.progressMessage = '';
			}, 1500);
		}
	}

	/**
	 * @method
	 */
	checkProgress() {
		const progressEl = this.progressEl,
			progressBarEl = this.progressBarEl,
			progressWrapperEl = this.progressWrapperEl;

		const progressKeys = _.keys(loadingQueue),
			hasProgress = progressKeys.length > 0;

		if (hasProgress) {
			this.completeProgressTimeout &&
				clearTimeout(this.completeProgressTimeout);
			this.hideProgressTimeout && clearTimeout(this.hideProgressTimeout);
			this.progressAwaitingCompletion = false;
		}

		if (hasProgress && !this.progressActive) {
			progressEl.classList.remove('disable-transition');
			progressEl.classList.add('active');
			this.progressActive = true;
			this.progressStalled = false;
		} else if (
			!hasProgress &&
			this.progressActive &&
			!this.progressAwaitingCompletion
		) {
			this.progressAwaitingCompletion = true;
			this.hangingProgressTimeout && clearTimeout(this.hangingProgressTimeout);

			this.completeProgressTimeout = setTimeout(() => {
				if (!this.progressAwaitingCompletion) return;

				this.progressComplete();

				this.hideProgressTimeout = setTimeout(() => {
					if (this.progressActive) return;

					this.progressHide();
				}, 500);
			}, 350);
		}

		this.drawProgress();
	}

	/**
	 * @method
	 */
	drawProgress() {
		if (this.drawing) return;

		const progressEl = this.progressEl,
			progressBarEl = this.progressBarEl,
			progressWrapperEl = this.progressWrapperEl;

		const draw = () => {
			this.progressAmt += (100 - this.progressAmt) * 0.015;
			progressBarEl.style.width = Math.min(this.progressAmt, 100) + '%';

			if (!this.progressActive) {
				this.drawing = false;
				return;
			}

			if (this.progressAmt >= 99 && !this.progressStalled) {
				this.progressStalled = true;
				this.hangingProgressTimeout = setTimeout(() => {
					if (!this.progressStalled) return;

					this.progressIndeterminate();
				}, 2000);
			}

			window.requestAnimationFrame(draw);
		};

		this.drawing = true;
		draw();
	}

	/**
	 * @method
	 * @param {number} chunk Chunk id
	 */
	loadingChunk(chunk) {
		loadingQueue['chunk:' + chunk] = true;
		this.checkProgress();
	}

	/**
	 * @method
	 * @param {number} chunk Chunk id
	 */
	loadedChunk(chunk) {
		delete loadingQueue['chunk:' + chunk];
		this.checkProgress();
	}

	/**
	 * @method
	 * @param {string} name Module name
	 * @param {number} progress Module overall init progress (for this round anyways)
	 * @param {boolean} deferred Module was deferred
	 */
	initializingModule(name, progress, deferred) {
		const key = ['module', name].join(':');

		loadingQueue[key] = true;
		initializingQueue[key] = {
			defered: deferred,
			progress: progress,
		};
		messageQueue[key] =
			'Initializing: ' + name + ((deferred && ' (deferred)') || '');

		this.checkMessage();
		this.checkProgress();
	}

	/**
	 * @method
	 * @param {string} name Module name
	 * @param {number} progress Module overall init progress (for this round anyways)
	 * @param {boolean} deferred Module was deferred
	 */
	initializedModule(name, progress, deferred) {
		const key = ['module', name].join(':');

		messageQueue[key] =
			'Initialized: ' + name + ((deferred && ' (deferred)') || '');
		setTimeout(() => {
			delete messageQueue[key];
			this.checkMessage();
		}, 500);

		delete loadingQueue[key];
		delete initializingQueue[key];

		this.checkMessage();
		this.checkProgress();
	}

	/** @method */
	progressHide() {
		this.progressWrapperEl.classList.remove('progress-striped');
		this.progressEl.classList.remove('active');
		this.progressEl.classList.add('disable-transition');
		this.progressBarEl.classList.remove('active');
		this.progressAmt = this.progressBarEl.style.width = 0;
	}

	/** @method */
	progressComplete() {
		this.progressAmt = 100;
		this.progressActive = this.progressStalled = false;
	}

	/** @method */
	progressIndeterminate() {
		this.progressWrapperEl.classList.add('progress-striped');
		this.progressBarEl.classList.add('active');
	}

	/**
	 * @method
	 * @param {function} cb Callback
	 */
	removeSplash(cb) {
		const $splashEl = $(this.splashEl);

		$splashEl.fadeOut('slow', function () {
			$splashEl.remove();
			_.isFunction(cb) && cb();
		});
	}

	/**
	 * @method
	 * @param {module:core/lib/netx-model|module:core/lib/netx-collection} thing Collection or model
	 * @param {string} namespace Namespace
	 * @param {string} fn RPC method name
	 */
	restLoading(thing, namespace, fn) {
		const key = ['rest', namespace, fn].join(':');

		loadingQueue[key] = true;

		const message = thing.getRestLoadingMessage(fn);
		if (message) {
			messageQueue[key] = _.isFunction(message) ? message.call(thing) : message;
			this.checkMessage();
		}

		this.checkProgress();
	}

	/**
	 * @method
	 * @param {module:core/lib/netx-model|module:core/lib/netx-collection} thing Collection or model
	 * @param {string} namespace Namespace
	 * @param {string} fn RPC method name
	 */
	restLoaded(thing, namespace, fn) {
		const key = ['rest', namespace, fn].join(':');

		const message = thing.getRestLoadedMessage(fn);
		if (message) {
			messageQueue[key] = _.isFunction(message) ? message.call(thing) : message;
			this.checkMessage();
			setTimeout(() => {
				delete messageQueue[key];
				this.checkMessage();
			}, 500);
		} else {
			delete messageQueue[key];
			this.checkMessage();
		}

		delete loadingQueue[key];
		this.checkProgress();
	}
}

export default Loading;
